import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { KEY_CODES } from 'constants'

import { ButtonSmall } from 'react-wot-bootstrap'

import { playCancelClickSound, playHoverSound } from 'state/actions/sounds'

import styles from './Confirmation.scss'

import { CLOSE_BUTTON_CAPTION } from './constants.jsx'

export class Confirmation extends React.Component {
    static propTypes = {
        title: PropTypes.node.isRequired,
        opened: PropTypes.bool.isRequired,
        submitCaption: PropTypes.node.isRequired,
        closeCaption:  PropTypes.node,
        onSubmit: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        playCancelClickSound: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
    }

    static defaultProps = {
        closeCaption: CLOSE_BUTTON_CAPTION,
    }

    constructor() {
        super()
        this.onKeyUp = this.onKeyUp.bind(this)
        this.handleCloseClick = this.handleCloseClick.bind(this)
        this.handleCloseHover = this.handleCloseHover.bind(this)
    }
    componentWillMount() {
        window.addEventListener('keydown', this.onKeyUp)
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyUp)
    }
    onKeyUp(e) {
        if (this.props.opened) {
            if (e.keyCode === KEY_CODES.ESCAPE) {
                this.props.onClose()
            }
            if (e.keyCode === KEY_CODES.ENTER) {
                this.props.onSubmit()
            }
        }
    }
    handleCloseClick() {
        this.props.playCancelClickSound()
        this.props.onClose()
    }
    handleCloseHover() {
        this.props.playHoverSound()
    }
    render() {
        const { opened, onSubmit, onClose, title, submitCaption } = this.props
        const className = classNames(styles.base, {
            [styles.base__opened]: opened,
            [styles.base__closed]: !opened,
        })

        return (
            <div className={className}>
                <div className={styles.overlay} />
                <div className={styles.wrapper}>
                    <div className={styles.body}>
                        <div className={styles.background}></div>
                        <header className={styles.header}>
                            <p className={styles.title}>{title}</p>
                            <button
                                className={styles.close}
                                onClick={this.handleCloseClick}
                                onMouseEnter={this.handleCloseHover}
                            />
                        </header>
                        <main className={styles.content}>
                            {this.props.children}
                        </main>
                        <footer className={styles.footer}>
                            <div className={styles.button}>
                                <ButtonSmall onClick={onSubmit}>
                                    {submitCaption}
                                </ButtonSmall>
                            </div>
                            <div className={styles.button}>
                                <ButtonSmall
                                    onClick={onClose}
                                    type={'secondary'}
                                    isCancel
                                >
                                    {this.props.closeCaption}
                                </ButtonSmall>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = { playCancelClickSound, playHoverSound }

export default connect(null, mapDispatchToProps)(Confirmation)



// WEBPACK FOOTER //
// ./components/Confirmation/Confirmation.jsx